import { useTranslation } from 'react-i18next';
import { Button } from '@components/ui/Button/Button';
import styles from './FilterNoMatches.module.css';

export interface IFilterNoMatchesProps {
  /** Clears every filter that narrows the view. */
  onClear: () => void;
  /** Placement only (padding, height) — the surrounding view's frame. */
  className?: string;
}

/**
 * The empty state of a view whose data is there but whose filters leave none
 * of it: says so, and offers the way back. Not for an empty site — that is an
 * onboarding moment with its own copy.
 */
export function FilterNoMatches({ onClear, className }: IFilterNoMatchesProps) {
  const { t } = useTranslation();
  return (
    <div className={className ? `${styles.root} ${className}` : styles.root}>
      <p className={styles.text}>{t('common.noFilterMatches')}</p>
      <Button variant="secondary" size="sm" onClick={onClear}>
        {t('common.clearFilters')}
      </Button>
    </div>
  );
}
